function initProductSingle() {
  // Initialize Swiper galleries if Swiper is loaded and the gallery element exists
  if (typeof Swiper !== 'undefined' && document.querySelector('.product-gallery')) {
    try {
      // Initialize thumbs swiper first
        var productThumbsSwiper = new Swiper(".product-gallery-thumb", {
        direction: "horizontal",
        spaceBetween: 16,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: ".product-gallery-next",
          prevEl: ".product-gallery-prev",
        },
        breakpoints: {
          0: {
            slidesPerView: 2, 
          },
          376: {
            slidesPerView: 3, 
          },
          481: {
            slidesPerView: 4, 
          },
          768: {
            direction: "vertical"
          }
        }
      });

      // Initialize main swiper next, linking it to the thumbs swiper
      var productMainSwiper = new Swiper(".product-gallery", {
        spaceBetween: 10,
        slidesPerView: 1,
        thumbs: {
          swiper: productThumbsSwiper,
        },
      });
    } catch (e) {
      console.warn("Swiper initialization failed:", e);
    }
  }
}

// Event Delegation for click & change events to avoid any lifecycle / dynamic loading issues
document.addEventListener('change', function (e) {
  // Handle quantity selector change
  var qtySelect = e.target.closest('.qty-select-overlay');
  if (qtySelect) {
    var qtyBox = qtySelect.closest('.qty-selector-box');
    if (qtyBox) {
      var qtyDisplay = qtyBox.querySelector('.qty-value');
      if (qtyDisplay) {
        qtyDisplay.textContent = qtySelect.options[qtySelect.selectedIndex].text;
      }
    }
  }
});

document.addEventListener('click', function (e) {
  // Handle product tabs switch
  var tabButton = e.target.closest('.tab-button');
  if (tabButton) {
    var container = tabButton.closest('.product-tabs-container');
    if (container) {
      var tabId = tabButton.getAttribute('data-tab');
      
      // Update active button
      container.querySelectorAll('.tab-button').forEach(function (btn) {
        btn.classList.remove('active');
      });
      tabButton.classList.add('active');

      // Update active panel
      container.querySelectorAll('.tab-panel').forEach(function (panel) {
        panel.classList.remove('active');
      });
      var targetPanel = container.querySelector('#tab-' + tabId);
      if (targetPanel) {
        targetPanel.classList.add('active');
      }
    }
  }

  // Handle bundle selection
  var option = e.target.closest('.choose-bundle .option');
  if (option) {
    var chooseBundle = option.closest('.choose-bundle');
    if (chooseBundle) {
      chooseBundle.querySelectorAll('.option').forEach(function (opt) {
        opt.classList.remove('selected');
      });
      option.classList.add('selected');
    }
  }

  // Handle See More click to scroll to Product Description
  var seeMoreLink = e.target.closest('.see-more-link');
  if (seeMoreLink) {
    e.preventDefault();
    
    var tabsContainer = document.querySelector('.product-tabs-container');
    if (tabsContainer) {
      // 1. Activate the Product Description tab if not already active
      var descButton = tabsContainer.querySelector('.tab-button[data-tab="description"]');
      if (descButton) {
        descButton.click(); // Trigger click on tab switcher delegation
      }
      
      // 2. Smoothly scroll to the tabs container
      var header = document.querySelector('.shopify-section-header') || document.querySelector('.header') || document.querySelector('header') || document.querySelector('.header-wrapper');
      var offset = header ? header.offsetHeight : 0;
      
      var bodyRect = document.body.getBoundingClientRect().top;
      var elementRect = tabsContainer.getBoundingClientRect().top;
      var elementPosition = elementRect - bodyRect;
      var offsetPosition = elementPosition - offset - 20;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }
});

// Run initialization safely when ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductSingle);
} else {
  initProductSingle();
}
